import Icon from '../components/Icon.vue'

Icon.register({
  microchip: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 48V464C416 490.5 394.5 512 368 512H144C117.5 512 96 490.5 96 464V48C96 21.5 117.5 0 144 0H368C394.5 0 416 21.5 416 48zM512 106V118A6-6 0 0 0 506 124H488V130A6-6 0 0 0 482 136H440V88H482A6-6 0 0 0 488 94V100H506A6-6 0 0 0 512 106zM512 202V214A6-6 0 0 0 506 220H488V226A6-6 0 0 0 482 232H440V184H482A6-6 0 0 0 488 190V196H506A6-6 0 0 0 512 202zM512 298V310A6-6 0 0 0 506 316H488V322A6-6 0 0 0 482 328H440V280H482A6-6 0 0 0 488 286V292H506A6-6 0 0 0 512 298zM512 394V406A6-6 0 0 0 506 412H488V418A6-6 0 0 0 482 424H440V376H482A6-6 0 0 0 488 382V388H506A6-6 0 0 0 512 394zM30 376H72V424H30A6-6 0 0 0 24 418V412H6A6-6 0 0 0 0 406V394A6-6 0 0 0 6 388H24V382A6-6 0 0 0 30 376zM30 280H72V328H30A6-6 0 0 0 24 322V316H6A6-6 0 0 0 0 310V298A6-6 0 0 0 6 292H24V286A6-6 0 0 0 30 280zM30 184H72V232H30A6-6 0 0 0 24 226V220H6A6-6 0 0 0 0 214V202A6-6 0 0 0 6 196H24V190A6-6 0 0 0 30 184zM30 88H72V136H30A6-6 0 0 0 24 130V124H6A6-6 0 0 0 0 118V106A6-6 0 0 0 6 100H24V94A6-6 0 0 0 30 88z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microchip.js
// module id = Pou6
// module chunks = 144